import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { FaroTextField } from "@components/common/faro-text-field/faro-text-field";
import { useDateTime } from "@hooks/use-date-time";
import { Grid } from "@mui-wrapper";
import { UiUtils } from "@stellar/utils";
import { CommonStyles } from "@styles/common-styles";
/** Defines the style of the border in between date sections */
const DEFAULT_BORDER = CommonStyles.Borders.divider;

/** Defines the default spacing between date sections */
const DEFAULT_SPACING = "20px";

/** Defines the margins in between the date sections */
const DATE_MARGINS = {
  mt: "4px",
  mb: DEFAULT_SPACING
};

/**
 * Shows the date details for a project. These include the creation, last captured and last updated dates.
 * They are displayed right below the main details of the project.
 */
export function DateDetails(t0) {
  const $ = _c(29);
  const {
    project,
    isLoading
  } = t0;
  const {
    formatDate
  } = useDateTime();
  if (isLoading || !project) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton variant="rectangular" height="45px" sx={DATE_MARGINS} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...DATE_MARGINS,
      justifyContent: "space-between"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      xs: 12,
      lg: 4
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== formatDate || $[4] !== project.createdAt) {
    t3 = formatDate(project.createdAt);
    $[3] = formatDate;
    $[4] = project.createdAt;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !!project.createdAt;
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Grid size={t2}><FaroTextField label="Creation Date" initialValue={t3} shouldShowTooltip={t4} /></Grid>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      borderLeft: {
        lg: DEFAULT_BORDER
      },
      py: {
        xs: DEFAULT_SPACING,
        lg: 0
      },
      px: {
        lg: DEFAULT_SPACING
      }
    };
    t7 = {
      xs: 12,
      lg: 4
    };
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== formatDate || $[12] !== project.lastCapturedAt) {
    t8 = project.lastCapturedAt ? formatDate(project.lastCapturedAt) : UiUtils.DASH;
    $[11] = formatDate;
    $[12] = project.lastCapturedAt;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = !!project.lastCapturedAt;
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <Grid sx={t6} size={t7}><FaroTextField label="Last Captured" initialValue={t8} shouldShowTooltip={t9} /></Grid>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      borderLeft: {
        lg: DEFAULT_BORDER
      },
      px: {
        lg: DEFAULT_SPACING
      }
    };
    t12 = {
      xs: 12,
      lg: 4
    };
    $[17] = t11;
    $[18] = t12;
  } else {
    t11 = $[17];
    t12 = $[18];
  }
  let t13;
  if ($[19] !== formatDate || $[20] !== project.modifiedAt) {
    t13 = formatDate(project.modifiedAt);
    $[19] = formatDate;
    $[20] = project.modifiedAt;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = !!project.modifiedAt;
  let t15;
  if ($[22] !== t13 || $[23] !== t14) {
    t15 = <Grid sx={t11} size={t12}><FaroTextField label="Last Updated" initialValue={t13} shouldShowTooltip={t14} /></Grid>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t10 || $[26] !== t15 || $[27] !== t5) {
    t16 = <Grid container={true} sx={t1}>{t5}{t10}{t15}</Grid>;
    $[25] = t10;
    $[26] = t15;
    $[27] = t5;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
}